import { apiPost } from "../baseApi";

export const invite = async (data) => {
  try {
    const response = await apiPost("_userInvite", data);
    return { ...response };
  } catch (error) {
    return Promise.reject(error);
  }
};
